// hooks/useGoogleMaps.js
import { useEffect, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";

export default function useGoogleMaps(apiKey) {
    const [google, setGoogle] = useState(null);

    useEffect(() => {
        if (!apiKey) {
            return;
        }

        const loadGoogleMaps = async () => {
            const loader = new Loader({
                apiKey,
                version: "beta",   // Use beta version for better PlaceAutocompleteElement support
                libraries: ["marker", "places"],
            });

            try {
                await loader.load();
                setGoogle(window.google);
            } catch (error) {
                console.error('Failed to load Google Maps:', error);
            }
        };

        loadGoogleMaps();
    }, [apiKey]);

    return google;           // null until loaded
}

// Helper function to parse Google Places address components
export function parseAddressComponents(place) {
    const addressComponents = place.addressComponents;

    const result = {
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        zip_code: '',
        country: '',
        latitude: null, // Will be set separately in AddressAutocomplete
        longitude: null, // Will be set separately in AddressAutocomplete
    };

    if (!addressComponents || !Array.isArray(addressComponents)) {
        return result;
    }

    for (const component of addressComponents) {
        const types = component.types;
        const value = component.longText || component.longName;

        if (types.includes('street_number')) {
            result.address_line1 = value;
        } else if (types.includes('route')) {
            result.address_line1 += (result.address_line1 ? ' ' : '') + value;
        } else if (types.includes('subpremise')) {
            result.address_line2 = value;
        } else if (types.includes('locality') || types.includes('sublocality')) {
            result.city = value;
        } else if (types.includes('administrative_area_level_1')) {
            result.state = value;
        } else if (types.includes('postal_code')) {
            result.zip_code = value;
        } else if (types.includes('country')) {
            result.country = value;
        }
    }

    return result;
}
